import React, { Component } from 'react';

class Confirmador extends Component {
    render() { 

        const {data,mensaje,elimina} = this.props;

        let invocador = elimina ? null : data.invocadorConfirmador; // para el botón cancelar se usa esta variable porque si se trata del Confirmador de eliminar no se debe invocar a ningún otro modal al cerrar

        return (  
        <div className='modaConfirmadorInterior'>
            <div>{mensaje}</div>

            <div className='footerTelefonosModal'>
                <button onClick={()=>this.props.funcionModalConfirmador("cancelar",invocador)} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>this.props.funcionModalConfirmador("confirmar",data.invocadorConfirmador)} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default Confirmador;